import { render } from "./CircularPieAddBG.vue?vue&type=template&id=a473e0c2"
import script from "./CircularPieAddBG.vue?vue&type=script&lang=js"
export * from "./CircularPieAddBG.vue?vue&type=script&lang=js"

import exportComponent from "D:\\项目\\王守岩代码\\长护险\\小爱到家长护险服务运营平台4.8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__